import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

export type GrupoExibicaoContextData = {
    openModalGrupoExibicao: boolean;
    setOpenModalGrupoExibicao: Dispatch<SetStateAction<boolean>>;
};

type GrupoExibicaoProviderData = {
    children?: ReactNode;
};

const GrupoExibicaoContext = createContext<GrupoExibicaoContextData>({} as GrupoExibicaoContextData);

export function GrupoExibicaoProvider({ children }: GrupoExibicaoProviderData) {
    const [openModalGrupoExibicao, setOpenModalGrupoExibicao] = useState<boolean>(false);

    const contextValue = useMemo(
        () => ({
            openModalGrupoExibicao,
            setOpenModalGrupoExibicao,
        }),
        [openModalGrupoExibicao],
    );

    return <GrupoExibicaoContext.Provider value={contextValue}>{children}</GrupoExibicaoContext.Provider>;
}

export const useGrupoExibicaoContext = (): GrupoExibicaoContextData => useContext(GrupoExibicaoContext);
